import FullModal from "../../../components/modal/full.modal";
import { useTranslation } from "react-i18next";
import Col from "../../../components/element/col";
import Icon from "../../../components/element/icon";
import Image from "../../../components/element/image";
import Row from "../../../components/element/row";
import sample from "../../../assets/images/consign/geran-sample.png";
import "./geran.guide.modal.scss";

const photoTips = [
  {
    icon: "solar:crop-minimalistic-linear",
    text: "Show the full geran with all four corners visible.",
  },
  {
    icon: "solar:magnifer-zoom-in-linear",
    text: "Make sure all text is sharp and readable.",
  },
  {
    icon: "solar:sun-2-linear",
    text: "Use even lighting without glare or shadows.",
  },
];

export default function GeranGuideModal({ onClose, onUpload }) {
  const { t } = useTranslation();
  return (
    <FullModal
      independent
      show
      close={onClose}
      showCloseButton
      centered
      screenSize="lg"
      className="product-action-modal geran-guide-modal"
      dialogClassName="action-modal-dialog guide-dialog"
      contentClassName="action-modal-content guide-panel"
      content={
        <Col className="guide-shell">
          <Row className="guide-header">
            <Col className="guide-header-copy">
              <h2>{t("How to take a clear geran photo?")}</h2>
              <p>
                {t(
                  "A clear photo helps us read your vehicle details accurately.",
                )}
              </p>
            </Col>
          </Row>
          <Col className="guide-body">
            <Row className="guide-content">
              <Col tag="figure" className="guide-sample">
                <Image
                  src={sample}
                  alt={t(
                    "Sample geran showing the full page and all four corners.",
                  )}
                  className="guide-image"
                />
              </Col>
              <Col className="guide-tips">
                <h3>{t("Before you upload")}</h3>
                <ol className="guide-tip-list">
                  {photoTips.map((tip) => (
                    <li key={tip.text}>
                      <span className="guide-tip-mark">
                        <Icon icon={tip.icon} />
                      </span>
                      <span className="guide-tip-text">{t(tip.text)}</span>
                    </li>
                  ))}
                </ol>
              </Col>
            </Row>
          </Col>
          <Col className="guide-footer">
            <button
              type="button"
              className="purchase-form-submit guide-upload"
              onClick={onUpload}
            >
              {t("Got It, Upload Now")}
            </button>
          </Col>
        </Col>
      }
    />
  );
}
